
import React, { useState, useEffect, useMemo } from 'react';
import CountrySelect from '../../Common-components/region/CountrySelect';
import RegionSelect from '../../Common-components/region/RegionSelect';
import PhoneCodeSelect from '../../Common-components/region/PhoneCodeSelect';
import '../../../css/Member/Register/registerForm.css';
import { apiPost } from '../../../utils/api';
import { countryValueToName, regionValueToName } from '../../../utils/locationOptions';
import CommonModal from '../../Common-components/Modal/modal';
import countries from 'i18n-iso-countries';
import ko from 'i18n-iso-countries/langs/ko.json';
import en from 'i18n-iso-countries/langs/en.json';
import * as countryCodes from 'country-codes-list';

countries.registerLocale(ko);
countries.registerLocale(en);

function RegisterForm({ onSuccess }) {

  const [formData, setFormData] = useState({
    id: '',
    password: '',
    confirmPassword: '',
    userName: '',
    birthdate: '',
    sex: '',
    phoneCode: '+82', // default +82
    phone: '',
    referralCode: '',
    country: 'KR',
    region: '',
    required1: false,
    required2: false,
    required3: false,
    required4: false,
    optional1: false,
    optional2: false,
    agreeAll: false,
  });

  const [isFormValid, setIsFormValid] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  // form 유효성 검사
  const requiredAgreementsData = useMemo(() => [
    { id: 'required1', label: '이용약관', modalContent: '이용약관 내용' },
    { id: 'required2', label: '개인정보 수집 및 이용동의', modalContent: '개인정보 수집 및 이용동의 내용' },
    { id: 'required3', label: '개인정보 취급 위탁', modalContent: '개인정보 취급 위탁 내용' },
    { id: 'required4', label: '포인트 약관', modalContent: '포인트 약관 내용' },
  ], []);

  const optionalAgreementsData = useMemo(() => [
    { id: 'optional1', label: '개인정보 3자 제공', modalContent: '개인정보 3자 제공 내용' },
    { id: 'optional2', label: '마케팅 목적 수집 및 활용 동의', modalContent: '마케팅 목적 수집 및 활용 동의' },
  ], []);

  const allAgreementIds = useMemo(() => [
    ...requiredAgreementsData.map(item => item.id),
    ...optionalAgreementsData.map(item => item.id),
  ], [requiredAgreementsData, optionalAgreementsData]);

  useEffect(() => {
    const allChecked = allAgreementIds.every(id => formData[id]);
    if (formData.agreeAll !== allChecked) {
      setFormData(prev => ({ ...prev, agreeAll: allChecked }));
    }
  }, [formData, allAgreementIds]);

  useEffect(() => {
    const {
      id,
      password,
      confirmPassword,
      userName,
      birthdate,
      sex,
      phoneCode,
      phone,
      country,
      required1,
      required2,
      required3,
      required4,
    } = formData;
    
    // 비밀번호 일치 확인 및 에러 메시지 설정
    if (confirmPassword && password !== confirmPassword) {
      setPasswordError('비밀번호가 일치하지 않습니다.');
    } else {
      setPasswordError('');
    }

    // 모든 필수 필드가 채워졌는지 확인
    const areInputsFilled =
      id &&
      password &&
      confirmPassword &&
      userName &&
      birthdate &&
      sex &&
      phoneCode &&
      phone &&
      country;

    // 필수 동의 항목이 모두 체크되었는지 확인
    const areAgreementsChecked =
      required1 &&
      required2 &&
      required3 &&
      required4;

    // 최종 폼 유효성
    setIsFormValid(
      areInputsFilled &&
      areAgreementsChecked &&
      password === confirmPassword
    );
  }, [formData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const nextValue = name === 'phone' ? value.replace(/[^0-9]/g, '') : value;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : nextValue,
    });
  };

  const handleBirthdateChange = (e) => {
    let value = e.target.value.replace(/[^0-9]/g, '');

    if (value.length > 8) {
      value = value.slice(0, 8);
    }

    if (value.length > 4) {
      value = value.substring(0, 4) + '-' + value.substring(4);
    }
    if (value.length > 7) {
      value = value.substring(0, 7) + '-' + value.substring(7);
    }

    setFormData({ ...formData, birthdate: value });
  };

  const handleAgreeAll = (e) => {
    const checked = e.target.checked;
    const agreementKeys = [
        ...requiredAgreementsData.map(a => a.id),
        ...optionalAgreementsData.map(a => a.id)
    ];
    const newAgreements = {};
    agreementKeys.forEach(key => {
        newAgreements[key] = checked;
    });

    setFormData({
      ...formData,
      ...newAgreements,
      agreeAll: checked,
    });
  };


  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!isFormValid) {
  //     // 버튼이 비활성화 상태이므로, 이 경고는 사실상 표시될 일이 거의 없습니다.
  //     // 하지만 만약을 위해 유지합니다.
  //     alert('입력 양식을 모두 올바르게 채워주세요.');
  //     return;
  //   }

  //   // if (formData.password !== formData.confirmPassword) {
  //   //   alert('비밀번호가 일치하지 않습니다.');
  //   //   return;
  //   // }

  //   const payload = {
  //     id: formData.id,
  //     password: formData.password,
  //     user_name: formData.userName,
  //     birthday: formData.birthdate.replace(/-/g, '/'),
  //     sex: formData.sex,
  //     phone: `${formData.phoneCode}${formData.phone}`,
  //     country: formData.country,
  //     region: formData.region,
  //     agree01: formData.required1 ? 'Y' : 'N',
  //     agree02: formData.required2 ? 'Y' : 'N',
  //     agree03: formData.required3 ? 'Y' : 'N',
  //     agree04: formData.required4 ? 'Y' : 'N',
  //     agree05: formData.optional1 ? 'Y' : 'N',
  //     rcv_email: formData.optional2 ? 'Y' : 'N'
  //   };

  //   try {
  //     const res = await apiPost('/member/register.php', payload);
  //     if (res.result === 'success') {
  //       alert('회원가입이 완료되었습니다.');
  //       console.log(res)
  //       // window.location.href = '/login';
  //     } else {
  //       alert(res.reason || '회원가입에 실패했습니다.');
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     alert('서버 오류가 발생했습니다.');
  //   }
  // };


const handleSubmit = async (e) => {
  e.preventDefault();

  if (!isFormValid) {
    alert('입력 양식을 모두 올바르게 채워주세요.');
    return;
  }

  const payload = {
    id: formData.id,
    password: formData.password,
    user_name: formData.userName,
    birthday: formData.birthdate.replace(/-/g, '/'),
    sex: formData.sex,
    phone: `${formData.phoneCode}${formData.phone}`,
    country: countryValueToName(formData.country),
    region: regionValueToName(formData.country, formData.region),
    agree01: formData.required1 ? 'Y' : 'N',
    agree02: formData.required2 ? 'Y' : 'N',
    agree03: formData.required3 ? 'Y' : 'N',
    agree04: formData.required4 ? 'Y' : 'N',
    agree05: formData.optional1 ? 'Y' : 'N',
    rcv_email: formData.optional2 ? 'Y' : 'N',
    referral_code: formData.referralCode.trim()
  };

  // ✅ 가입 확인 모달 띄우기
  alert({
    title: '다시 한번 확인해 주세요.',
    content: <p>휴대폰 번호를 잘못 입력한 경우나 해외 번호인 경우에는 예약 관련 <span style={{color:'#0066FF'}}>카카오 알림 톡</span>을 받을 수 없습니다. 휴대폰 번호는 가입 후 마이페이지에서 수정할 수 있습니다.</p>,
    confirmButtonText: '닫기',
    footerContent: <button type="button" className="btn" >회원가입 하기</button>,
    action: async () => {
      try {
        const res = await apiPost('/member/register.php', payload);
        if (res.result === 'success') {
          console.log(res)
          onSuccess(payload); // 성공시 부모 한테 데이터 전달
          // alert('회원가입이 완료되었습니다.');
          // window.location.href = '/login'; // 가입 후 로그인 이동
        } else {
          alert({
            title: '에러',
            content: <p>{res.reason || '회원가입에 실패했습니다.'}</p>
          });
        }
      } catch (error) {
        console.error(error);
        alert({
          title: '에러',
          content: <p>서버 오류가 발생했습니다.<br/>잠시후 다시 시도해 주세요.</p>
        });
      }
      // console.log(payload)
    }
  });
};

  const phoneOptions = useMemo(() => {
    const cc = (countryCodes && countryCodes.customList)
      ? countryCodes
      : (countryCodes && countryCodes.default && countryCodes.default.customList)
        ? countryCodes.default
        : null;
    if (!cc) {
      return [];
    }
    const rawMap = cc.customList('countryCode', '{countryNameEn}|{countryCallingCode}');
    const list = Object.entries(rawMap).map(([alpha2, str]) => {
      const [nameEnFromList, calling] = str.split('|');
      const nameKo = countries.getName(alpha2, 'ko');
      const nameEnIso = countries.getName(alpha2, 'en');
      const name = nameKo || nameEnIso || nameEnFromList || alpha2;
      const dial = calling ? `+${calling}` : '';
      return dial ? { alpha2, name, dial } : null;
    }).filter(Boolean);

    const priority = ['KR', 'US', 'JP']; // 상단 우선 순위(순서 보장 X)
    const prio = list.filter(o => priority.includes(o.alpha2));
    const rest = list.filter(o => !priority.includes(o.alpha2)).sort((a, b) => a.name.localeCompare(b.name, 'ko'));
    return [...prio, ...rest];
  }, []);

  return (
    <div className="register-container">
      <h2 className="register-title">회원가입</h2>
      <form onSubmit={handleSubmit} className="register-form">
        {/* 아이디 */}
        <div className="form-group">
          <label htmlFor="id" className="input-label">
            아이디(이메일 주소)<span>*</span>
          </label>
          <input
            type="email"
            id="id"
            name="id"
            placeholder="이메일 주소를 입력해 주세요."
            value={formData.id}
            onChange={handleChange}
            className="register-input"
            required
          />
        </div>

        {/* 비밀번호 */}
        <div className="form-group">
          <label htmlFor="password" className="input-label">비밀번호<span>*</span></label>
          <input
            type="password"
            id="password"
            name="password"
            placeholder="영문, 숫자, 특수문자 1개 이상, 8자 이상"
            value={formData.password}
            onChange={handleChange}
            className="register-input"
            maxLength="20"
            required
          />
        </div>

        {/* 비밀번호 확인 */}
        <div className="form-group">
          <label htmlFor="confirmPassword" className="input-label">비밀번호 확인<span>*</span></label>
          <input
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            placeholder="비밀번호를 재입력해 주세요."
            value={formData.confirmPassword}
            onChange={handleChange}
            className="register-input"
            maxLength="20"
            required
          />
          {passwordError && <div className="password-error">{passwordError}</div>}
        </div>

        {/* 이름 */}
        <div className="form-group">
          <label htmlFor="userName" className="input-label">이름<span>*</span></label>
          <input
            type="text"
            id="userName"
            name="userName"
            placeholder="이름을 입력해 주세요."
            value={formData.userName}
            onChange={handleChange}
            className="register-input"
            required
          />
        </div>

        {/* 국가 / 지역 */}
        <div className="form-group">
          <label className="input-label">거주 국가<span>*</span></label>
          <div className='region-select-wrapper'>
            <CountrySelect
              value={formData.country}
              onChange={(val) => setFormData({ ...formData, country: val, region: '' })}
              className="register-input"
              defaultOptionLabel="국가"
            />
            <RegionSelect
              country={formData.country}
              value={formData.region}
              onChange={(val) => setFormData({ ...formData, region: val })}
              className="register-input"
              defaultOptionLabel="지역"
            />
          </div>
        </div>

        {/* 생년월일 */}
        <div className="form-group">
          <label htmlFor="birthdate" className="input-label">생년월일<span>*</span></label>
          <input
            type="text"
            id="birthdate"
            name="birthdate"
            placeholder="생년월일을 입력해 주세요. (예:2024-01-02)"
            value={formData.birthdate}
            onChange={handleBirthdateChange}
            className="register-input"
            maxLength="10"
            required
          />
        </div>

        {/* 성별 */}
        <div className="form-group gender-group">
          <label className="input-label" style={{marginBottom:'0'}}>성별<span>*</span></label>
          <div className="radio-group">
            <label className="radio-label">
              <input
                type="radio"
                name="sex"
                value="M"
                checked={formData.sex === 'M'}
                onChange={handleChange}
                required
              />
              남성
            </label>
            <label className="radio-label">
              <input
                type="radio"
                name="sex"
                value="F"
                checked={formData.sex === 'F'}
                onChange={handleChange}
              />
              여성
            </label>
          </div>
        </div>

        {/* 휴대폰 번호 + 국가번호 */}
        <div className="form-group phone-group">
          <label htmlFor="phone" className="input-label">휴대폰 번호<span>*</span></label>
          <div className='phone-input-wrapper'>
            <PhoneCodeSelect
              value={formData.phoneCode || ''}
              onChange={(val) => setFormData(prev => ({ ...prev, phoneCode: val }))}
              options={phoneOptions}
              className="register-input"
            />
            <input
              type="tel"
              id="phone"
              name="phone"
              placeholder="번호를 입력해 주세요."
              value={formData.phone}
              onChange={handleChange}
              className="register-input"
              required
            />
          </div>
          <span style={{
            paddingTop:'4px',
            fontWeight:'400',
            fontSize: '13px',
            lineHeight: '160%',
            color:'#7B8492'}}>*휴대폰 번호를 잘못 입력한 경우나 해외 번호의 경우 예약 관련 '카카오 알림 톡'을 받으실 수 없습니다.</span>
        </div>

        <div className="form-group">
          <label htmlFor="referralCode" className="input-label">추천인 코드</label>
          <input
            type="text"
            id="referralCode"
            name="referralCode"
            placeholder="추천인 코드가 있는 경우 입력해 주세요."
            value={formData.referralCode}
            onChange={handleChange}
            className="register-input"
            maxLength="50"
          />
        </div>

        {/* 동의 항목 */}
        <div className="agreements">
          <div className="form-group select">
            <input
              type="checkbox"
              name="agreeAll"
              id='agreeAll'
              checked={formData.agreeAll}
              onChange={handleAgreeAll}
            />
            <label for="agreeAll" className="checkbox-label agree-all">
              전체 동의하기
            </label>
          </div>

          <div className='divider-hr'></div>
          <div className='agreement-wrapper'>
            {requiredAgreementsData.map((agreement) => (
              <div className="form-group agreement-item" key={agreement.id}>
                <input
                  type="checkbox"
                  id={agreement.id}
                  name={agreement.id}
                  checked={formData[agreement.id]}
                  onChange={handleChange}
                  required
                />
                <div className='label-box'>
                  <label for={agreement.id} className="checkbox-label required">
                    <span className='label-badge blue'>(필수)</span><span className='label-name'>{agreement.label}</span>
                  </label>
                  <CommonModal
                    trigger={<span className='view-detail-terms'>보기</span>}
                    title={agreement.label}
                    showFooter={false}
                  >
                    {agreement.modalContent}
                  </CommonModal>
                </div>
              </div>
            ))}

            {optionalAgreementsData.map((agreement) => (
              <div className="form-group agreement-item" key={agreement.id}>
                <input
                  type="checkbox"
                  id={agreement.id}
                  name={agreement.id}
                  checked={formData[agreement.id]}
                  onChange={handleChange}
                />
                <div className='label-box'>
                  <label for={agreement.id} className="checkbox-label optional">
                    <span className='label-badge teritary'>(선택)</span><span className='label-name'>{agreement.label}</span>
                  </label>
                  <CommonModal
                    trigger={<span className='view-detail-terms'>보기</span>}
                    title={agreement.label}
                    showFooter={false}
                  >
                    {agreement.modalContent}
                  </CommonModal>
                </div>
              </div>
            ))}
          </div>
        </div>

        <button type="submit" className="register-button" disabled={!isFormValid}>회원가입 하기</button>
      </form>
    </div>
  );
}

export default RegisterForm;
